import Api from './Connect.api.js';
import {
  countryChannelMapping,
  removedIntegrations,
  includeCountryMap,
  excludeCountryMap
} from 'Modules/Connect/components/ConnectStoreList/utility.jsx';
import {
  filter as _filter,
  find as _find,
  forEach as _forEach,
  isEmpty as _isEmpty,
  groupBy as _groupBy,
  uniq as _uniq,
  isUndefined as _isUndefined,
  includes as _includes
} from 'lodash-es';

import { createAsyncThunk, createAction } from '@reduxjs/toolkit';

// --- Format :: new API('API URL', 'API SERVICE NAME - from api_service.jsx')
const storeList = new Api('services/', 'account');

export const updateSelectedStore = (payload, channelName) => {
  return async dispatch => {
    try {
      const apiData = await storeList.updateSelectedStore(payload, channelName);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        return data;
      }
    } catch (error) {
      return error;
    }
  };
};

export const updateCategoryStore = (payload, channelName) => {
  return async dispatch => {
    try {
      const apiData = await storeList.updateCategoryStore(payload, channelName);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        return data;
      }
    } catch (error) {
      return error;
    }
  };
};

export const getAccountCategories = async (channelName, countryCode, url, merchantID, nickNameId) => {
  let path = '';
  if (merchantID && nickNameId) {
    path = `${url}/uploads/accountCategory/${channelName}/${countryCode}/${merchantID}/${nickNameId}.json`;
  } else {
    path = `${url}/uploads/category/${channelName}/${countryCode}.json`;
  }
  try {
    const response = await storeList.getAccountCategories(path);
    return response;
  } catch (error) {
    return [];
  }
};

export const getBrands = async (channelName, countryCode, url, merchantID, nickNameId) => {
  let path = `${url}/uploads/brand/${channelName}/${countryCode}.json`;
  try {
    const response = await storeList.getAccountCategories(path);
    return response;
  } catch (error) {
    return [];
  }
};

export const syncPolicy = (channelName, payload) => {
  let apiData = {};
  return async dispatch => {
    try {
      apiData = await storeList.syncPolicy(channelName, payload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        return data;
      }
    } catch (error) {
      return error;
    }
  };
};

export const getStoreList = createAsyncThunk('connect/getStoreList', async (payloadObject, { rejectWithValue }) => {
  const { countryCode, intentChannels = [] } = payloadObject;
  try {
    const apiData = await storeList.getStoreList(countryCode);
    if (apiData && apiData?.hasError) {
      const errorObj = apiData;
      throw new Error(errorObj);
    } else {
      const { data } = apiData;
      let updatedList = data?.data;
      const channelsByCountryCode = countryChannelMapping[countryCode] || countryChannelMapping.default;
      // ! check country code and prioritize list
      if (channelsByCountryCode && !_isEmpty(data?.data)) {
        let foundRecords = [];
        _forEach(_uniq([...intentChannels, ...channelsByCountryCode]), channel => {
          const found = _find(data?.data, item => item?.key === channel);
          if (found) {
            foundRecords?.push(found);
          }
        });
        const restRecords =
          _filter(
            data?.data,
            item =>
              item?.category === 'chatInquiry' ||
              !_uniq([...intentChannels, ...channelsByCountryCode])?.includes(item.key)
          ) || [];
        updatedList = [...foundRecords, ...restRecords];
      }
      let newFullList = _filter(updatedList, ({ key: channelName }) => {
        const includeCountryCodes = includeCountryMap[channelName];
        const excludeCountryCodes = excludeCountryMap[channelName];

        // If the country is in the exclude list, filter it out
        if (_includes(excludeCountryCodes, countryCode)) {
          return false;
        }

        // If an include list exists, only include if it matches the country code
        return !includeCountryCodes || _includes(includeCountryCodes, countryCode);
      });

      let channelNameList = [];
      _forEach(newFullList, channelItem => {
        channelNameList?.push(channelItem?.key);
      });

      const groupedList = _groupBy(newFullList, 'category') || {};
      // !-- removed integration filtering
      const filteredByRemoved = _filter(newFullList, item => !removedIntegrations?.includes(item.key)) || [];
      return { updatedList: filteredByRemoved, channelNameList, groupedList };
    }
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const getIntegrationErrorMappings = createAsyncThunk('connect/getIntegrationErrorMappings', async () => {
  try {
    const apiData = await storeList.getIntegrationErrorMappings();
    if (apiData && apiData?.hasError) {
      const errorObj = apiData;
      throw new Error(errorObj);
    } else {
      const { data } = apiData;
      return data;
    }
  } catch (err) {
    return err;
  }
});

export const setSingleValue = createAction('connect/setSingleValue');
